export default "__VITE_ASSET__B4t5R13$__"